<div>
  <div class="container">
    <div class="header">
      @if(!isLoading()) {
      <button mat-icon-button mat-dialog-close>
        <mat-icon>close</mat-icon>
      </button>
      }
    </div>

    <div class="content">
      @if(pdfPreview().length > 0) {
      <soph-file-stepper>
        @for(item of pdfPreview(); track item) {
        <cdk-step>
          <img [src]="item.imageUrl" class="pdf-image" />

          <ng-template
            [ngTemplateOutlet]="actions"
            [ngTemplateOutletContext]="{ data: item }"
          ></ng-template>
        </cdk-step>
        }
      </soph-file-stepper>
      } @else { }
    </div>

    <ng-template #actions let-data="data">
      <div class="footer">
        <button mat-flat-button color="primary" (click)="printPdf()">
          <mat-icon>print</mat-icon>Imprimir
        </button>

        <button mat-flat-button color="primary" (click)="downloadPdf()">
          <mat-icon>download</mat-icon>Descargar
        </button>

        <button
          mat-flat-button
          color="primary"
          (click)="sendPdf()"
          [disabled]="isSendingAction()"
          class="send-action"
        >
          @if(isSendingAction()) {
          <mat-spinner diameter="24"></mat-spinner>
          } @else {
          <mat-icon>forward_to_inbox</mat-icon>
          <span>Enviar</span>
          }
        </button>
      </div>
    </ng-template>
  </div>
</div>
